import { render } from "./OrdersRow.vue?vue&type=template&id=68db18a1"
import script from "./OrdersRow.vue?vue&type=script&lang=js"
export * from "./OrdersRow.vue?vue&type=script&lang=js"

import "./OrdersRow.vue?vue&type=style&index=0&id=68db18a1&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__